import PropTypes from 'prop-types';
import { useEffect } from 'react';

import gtmService from 'services/gtmService';
import productData from 'services/productData';
import { getAppNameByID } from 'services/utility';

const LogoutPage = ({ location }) => {
    function getAppShortName(app) {
        const appName = productData.hasOwnProperty(app) ? productData[app] : productData.OCM;
        return appName.shortname;
    }

    function trackLogoutOrigin(query) {
        try {
            const params = new URLSearchParams(query);
            const appParam = params.get('app');
            const redirectParam = params.get('redirect');
            console.log('Logout detected from app:', getAppShortName(getAppNameByID(appParam)));
            console.log('Redirect URL:', redirectParam);
            gtmService.sendLogoutSuccessEvent();
        } catch (error) {
            console.error('Failed to parse query string:', error);
        }
    }

    useEffect(() => {
        // Clear login session cookies
        let query = '';
        if (location?.search) {
            query = (location.search[0] === '?' ? '' : '?') + location.search;
        }
        // Get returnTo on query parameters
        const params = new URLSearchParams(query);
        let returnTo;
        if (params.get('returnTo')) {
            returnTo = params.get('returnTo');
        } else {
            returnTo = `${location.origin}/login${query}`;
        }
        trackLogoutOrigin(query);
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}/logout?returnTo=${encodeURIComponent(returnTo)}`;
    }, [location]);

    return <></>;
};

export default LogoutPage;

LogoutPage.propTypes = {
    location: PropTypes.object
};
